// extracted by mini-css-extract-plugin
export default {"event":"EventTitle-module__event___pgQ_r","title":"EventTitle-module__title___rm1S5","titleInput":"EventTitle-module__titleInput___r0x8t"};